// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3QVm-","list":"PatternAutocomplete_list__2EXRY"};